<template>
  <app-card body-class="flex flex-col gap-6">
    <transfer-recipient-badge
      :transfer-recipient="transferRecipient"
      :is-loading="isPending"
    />

    <div class="flex flex-col gap-3">
      <data-property
        label="Email"
        direction="horizontal"
        :is-loading="isPending"
      >
        <template #value>
          <text-truncate
            :value="transferRecipient?.email"
            :max-length="32"
            break-word
          />
        </template>
      </data-property>
      <data-property
        label="Created on"
        direction="horizontal"
        :value="formatDate(transferRecipient?.created_at, 'L @LT')"
        :is-loading="isPending"
      />
    </div>

    <div
      class="flex gap-3 [&>*]:flex-1"
      data-cy="reservation-drawer-action-buttons"
    >
      <button
        v-if="canEditRecipient"
        class="btn btn-sm btn-secondary"
        @click="$emit('edit:transfer-recipient', transferRecipientId)"
      >
        <app-icon
          name="edit"
          size="sm"
        />
        Edit Details
      </button>
      <transfer-recipient-identifier-modal
        :agency-id="agencyId"
        :transfer-recipient-id="transferRecipientId"
      />
    </div>
  </app-card>
</template>

<script setup>
import { computed, toRef } from 'vue';
import { formatDate } from '@/utils/dates.js';
import { useAuthStore } from '@/stores/auth';
import { useTransferRecipientById } from '@/services/transfer-recipients/queries.js';
import TransferRecipientBadge from '@/components/transfer-recipients/TransferRecipientBadge.vue';
import TransferRecipientIdentifierModal from '@/components/transfer-recipients/TransferRecipientIdentifierModal.vue';

const props = defineProps({
  agencyId: {
    type: String,
    required: true,
  },
  transferRecipientId: {
    type: String,
    required: true,
  },
});

const authStore = useAuthStore();

const canEditRecipient = computed(() => authStore.hasPermission('transfer_recipient:edit'));

const { data, isPending } = useTransferRecipientById(toRef(props, 'transferRecipientId'));
const transferRecipient = computed(() => data?.value?.data || {});
</script>
